/**
 * @name setOneScroll.js
 */

class setOneScroll {
    constructor() {
        this.html = document.querySelector('html');
        this.hero = document.querySelector('#hero');
        this.splash = document.querySelector('#splash');
        this.body = document.querySelector('#body');

        this.__init();
        this.__observeBody();
    }

    /**
     * @name __init
     */
    __init() {
        this.hero.addEventListener('wheel', (event) => this.__handleScroll(event, 'body'));
        this.body.addEventListener('wheel', (event) => this.__handleScroll(event, 'hero'));
        this.splash.addEventListener('wheel', (event) => this.__handleScroll(event, 'body'));
    }

    /**
     * @name __handleScroll
     */
    __handleScroll(event, target) {
        if ((target === 'body' && event.deltaY > 0) || (target === 'hero' && event.deltaY < 0)) {
            event.preventDefault();
            this[target].scrollIntoView({ behavior: 'smooth' });
        }
    }

    /**
     * @name __observeBody
     */
    __observeBody() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.html.classList.add('isEntry');
                } else {
                    this.html.classList.remove('isEntry');
                }
            });
        }, { threshold: 0.1 });

        observer.observe(this.body);
    }
}

export default setOneScroll;